import { ProductHit } from "@/components/products-tile/product";
import { createSlice } from "@reduxjs/toolkit";

const initialState: ProductHit[] = [];

export const compareProductsSlice = createSlice({
  name: "compareProductsSlice",
  initialState,
  reducers: {
    toggleItemForComparison: (state, action) => {
      const currentIndex = state.findIndex((item: ProductHit) => item.mp_id === action.payload.mp_id);

      if (currentIndex >= 0) state.splice(currentIndex, 1);
      else if (state.length < 4) state.push(action.payload);
      return state;
    },

    clearByIndex: (state, action) => {
      const currentIndex = action.payload;

      if (currentIndex >= 0) state.splice(currentIndex, 1);
      return state;
    },

    clearAll: () => {
      return [];
    },
  },
});

export const { toggleItemForComparison, clearAll, clearByIndex } = compareProductsSlice.actions;
export default compareProductsSlice;
